import { render, staticRenderFns } from "./RecruitContent.vue?vue&type=template&id=5ae147e8&scoped=true"
import script from "./RecruitContent.vue?vue&type=script&lang=ts"
export * from "./RecruitContent.vue?vue&type=script&lang=ts"
import style0 from "./RecruitContent.vue?vue&type=style&index=0&id=5ae147e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae147e8",
  null
  
)

export default component.exports